import { createAsyncThunk } from '@reduxjs/toolkit';
// oxlint-disable-next-line cian-eslint-compat/no-restricted-paths
import { resolveUser } from '../../../shared/services/user';
import { setUser } from '../../../shared/slices/userReduces';
import { IThunkApi } from '../../../shared/types/redux';
import { TUserResolve } from '../../../shared/types/currentUser';

export const getUserAction = createAsyncThunk<TUserResolve, void, IThunkApi>(
  'user/getUserAction',
  async (_, thunkApi) => {
    const {
      dispatch,
      extra: { httpApi, logger, config },
    } = thunkApi;
    const user = await resolveUser({ config, httpApi, logger });
    dispatch(setUser(user));

    return user;
  },
);
